import React from 'react';
import classNames from 'classnames';

import './StandardButton.scss';
import Button, { ButtonVariant } from 'components/base/Button';
import { capitalizeFirstLetter } from 'utils/helpers';

interface StandardButtonProps {
  buttonText: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  variant?: ButtonVariant;
  fullWidth?: boolean;
  // maxWidth?:string;
  afterImage?: string | React.ReactNode;
  beforeImage?: string | React.ReactNode;
  IsShowBadge?: boolean;
  isLoading?: boolean;
}

const CustomStandardButton = ({
  buttonText,
  onClick,
  className,
  type = 'button',
  disabled,
  variant = 'danger',
  IsShowBadge,
  isLoading,
  afterImage,
  beforeImage
}: StandardButtonProps) => {
  const classes = classNames(
    'btn',
    'btn-block',
    'p-0',
    'standard-button',
    IsShowBadge ? 'position-relative' : null,
    className,
    {
      disabled: disabled || isLoading,
      loader: isLoading
    }
  );

  return (
    <Button variant={variant} onClick={onClick} type={type} className={classes}>
      {beforeImage && beforeImage}
      {buttonText && (
        <div className="fs-8">{capitalizeFirstLetter(buttonText)}</div>
      )}
      {afterImage && afterImage}
    </Button>
  );
};

export default CustomStandardButton;
export const StandardButton = React.memo(CustomStandardButton);
